import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { CmsService } from '../../cms.service';
import { Observable, ReplaySubject } from 'rxjs';
import { ProductService } from '../../../services/product.service';
import { AppState } from 'src/app/store/app.reducer';
import { Store } from '@ngrx/store';
import { LOCALE_ID, LOCALE_STATE } from '../../../shared/constants';
import { DynamicPathRoutingService } from '../../../services/dynamic-path-routing.service';
import { PACK_DETAILS_COMPONENT_NAME, PRODUCT_COMPONENT_NAME, PRODUCT_DETAILS_COMPONENT_NAME } from '../../../ComponentsIndex';
import { DynamicPathStorageService } from '../../../services/dynamic-path-storage.service';
import { CategoryService } from 'src/app/services/category.service';

@Component({
  selector: 'hro-product-set',
  templateUrl: './block-product-set.component.html',
  styleUrls: ['./block-product-set.component.scss'],
})
export class BlockProductSetComponent implements OnInit, OnDestroy {
  @Input() componentId: any;
  data: any;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  public currentLocale: string;

  productDetailsPageUrlPattern: string;
  packDetailsPageUrlPattern: string;
  readonly PRODUCT_PRODUCT_TYPE = 'PRODUCT';
  productListPageUrl$: Observable<string> = new Observable<string>();

  constructor(
    private productService: ProductService,
    private cmsService: CmsService,
    private store: Store<AppState>,
    private dynamicPathRoutingService: DynamicPathRoutingService,
    private dynamicPathStorageService: DynamicPathStorageService,
    private categoryService: CategoryService
  ) {}

  ngOnInit(): void {
    this.store
      .select(LOCALE_STATE, LOCALE_ID)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(localeId => {
        this.currentLocale = localeId;
        this.getComponentData();
      });

    this.dynamicPathStorageService.urlPatterns$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      this.productDetailsPageUrlPattern =
        this.dynamicPathStorageService.getUrlPatternByComponentNameFromCmsPageList(PRODUCT_DETAILS_COMPONENT_NAME);
      this.packDetailsPageUrlPattern =
        this.dynamicPathStorageService.getUrlPatternByComponentNameFromCmsPageList(PACK_DETAILS_COMPONENT_NAME);
    });

    this.productListPageUrl$ = this.dynamicPathStorageService.urlPatterns$.pipe(
      takeUntil(this.destroyed$),
      map(() => {
        this.categoryService.next(null);
        const urlPattern = this.dynamicPathStorageService.getUrlPatternByComponentNameFromCmsPageList(PRODUCT_COMPONENT_NAME);
        return urlPattern?.startsWith('/') ? urlPattern : '/' + urlPattern;
      })
    );
  }

  getComponentData() {
    this.cmsService
      .getCmsComponentById(this.componentId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(res => {
        this.data = res.cmsContents.filter(element => element.context.id === this.currentLocale);
      });
  }

  getImage(image: any, format: string | null): any {
    if (!image) {
      return;
    }
    return this.productService.downloadMedia(image, format);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  counter(i) {
    return new Array(Math.floor(i));
  }
}
